
  /* eslint-disable */

// Global theme setter used by pages/components.
// Important: do not set data-theme if the value is already the same.
// This prevents MutationObserver -> setAttribute -> MutationObserver loops during route changes.
if (typeof window !== "undefined") {
  window.__flockrSetTheme = function(theme) {
    var next = theme === "dark" ? "dark" : "light";
    var html = document && document.documentElement;
    if (html && html.getAttribute("data-theme") !== next) {
      html.setAttribute("data-theme", next);
    }
    try { localStorage.setItem("flockr_theme", next); } catch (e) {}
  };

  // Default theme is LIGHT. If the user has never set a preference, persist 'light'
  // so every component's `localStorage.getItem('flockr_theme') || 'dark'` fallback resolves to 'light'.
  try {
    if (!localStorage.getItem("flockr_theme")) {
      localStorage.setItem("flockr_theme", "light");
    }
    window.__flockrSetTheme(localStorage.getItem("flockr_theme") || "light");
  } catch (e) {}
}

  import { createApp } from 'vue'
  import App from './App.vue'
  import router from "@/router";
  import vueHelmet from "vue-helmet/src/VueHelmet";
  import * as VueGoogleMaps from "vue3-google-map";
/*  import IdleVue from 'idle-vue'*/
  import IdleVue from "idle-vue";


  const app = createApp(App);

  app.use(VueGoogleMaps,{ load: {key: "AIzaSyAGPbYfcYqdbSBeXdIpH5iWrznfU886Qk8"}})
  app.use(router)
  app.use(vueHelmet)

/*  app.use(IdleVue, {
    eventEmitter: app,
    idleTime: 20000,
    startEventName: "load",
    resetEvents: ["click", "mousemove", "keydown", "touchstart"],
    idleTimeoutCallback: () => {
      app.$router.push("/");
    },
  });*/
  app.mount("#app");




